import React, { useState } from 'react';
import { Field, Input } from '@itds/elements';
import { Api } from '@carrier/utils/Api';
import { useParams } from 'react-router';

function WithdrawalsAndSurrenders() {
    const params = useParams();
    const [withdrawal, setWithdrawal] = useState(null);

    React.useEffect(() => {
        const getWithdrawalAndSurrenders = () => {
            Api.loadWithdrawalsAndSurrenders(params.version_id)
            .then((response) => {
                setWithdrawal((prev) => ({ ...prev, ...response.data }));
            })
            .catch((error) => {
                console.error('Error loading withdrawals and surrenders:', error);
            });
        }

        getWithdrawalAndSurrenders();
    }, [params.version_id]);

    const getChangeValue = (eOrValue) =>
        eOrValue && typeof eOrValue === 'object' && 'target' in eOrValue
        ? eOrValue.target.value
        : eOrValue;

    const handleInputChange = (key) => (eOrValue) => {
        const value = getChangeValue(eOrValue);
        setWithdrawal((prev) => ({ ...prev, [key]: value }));
    };

    return (
    <>
      <Field label="Free Withdrawal %" style={{}}>
        <Input
          value={withdrawal?.free_withdrawal_percentage}
          onChange={handleInputChange('free_withdrawal_percentage')}
        />
      </Field>

      <Field label="MVA Factor (long text string)" style={{}}>
        <Input  
          value={withdrawal?.mva_factor}
          onChange={handleInputChange('mva_factor')}
        />
      </Field>

    {withdrawal?.surrender_years_rates?.length > 0 && (
        <div style={{ marginTop: 8 }}>
        <h3 style={{ margin: '8px 0' }}>Surrender Charges by Year</h3>
        {withdrawal?.surrender_years_rates?.map((val, idx) => (
            <Field key={idx} label={`Year ${idx + 1}`} style={{}}>
            <Input
                value={val}
                onChange={eOrValue => {
                const value = getChangeValue(eOrValue);
                setWithdrawal(prev => {
                    const nextYears = [...prev.surrender_charge_years];
                    nextYears[idx] = value;
                    return { ...prev, surrender_charge_years: nextYears };
                });
                }}
            />
            </Field>
        ))}
        </div>
    )}

      <Field label="Fee Based" style={{}}>
        <Input
          value={withdrawal?.fee_based}
          onChange={handleInputChange('fee_based')}
        />
      </Field>

      <div style={{ marginTop: 16 }}>
        <h3 style={{ margin: '8px 0' }}>Waivers</h3>

        <Field label="Waive on Death" style={{}}>
          <Input
            value={withdrawal?.waive_on_death}
            onChange={handleInputChange('waive_on_death')}
          />
        </Field>
        <Field label="Annuitization Waiver" style={{}}>
          <Input
            value={withdrawal?.waive_on_annuity}
            onChange={handleInputChange('waive_on_annuity')}
          />
        </Field>
        <Field label="Waiver for Disability" style={{}}>
          <Input
            value={withdrawal?.waivers_for_disability}
            onChange={handleInputChange('waivers_for_disability')}
          />
        </Field>
        <Field label="Waiver for Nursing Home" style={{}}>
          <Input
            value={withdrawal?.waivers_for_nursing_home}
            onChange={handleInputChange('waivers_for_nursing_home')}
          />
        </Field>
        <Field label="Hospital Waiver" style={{}}>
          <Input
            value={withdrawal?.hospital_waiver}
            onChange={handleInputChange('hospital_waiver')}
          />
        </Field>
        <Field label="Terminal Illness Waiver" style={{}}>
          <Input
            value={withdrawal?.terminal_illness_waiver}
            onChange={handleInputChange('terminal_illness_waiver')}
          />
        </Field>
        <Field label="Unemployment Waiver" style={{}}>
          <Input
            value={withdrawal?.unemployment_waiver}
            onChange={handleInputChange('unemployment_waiver')}
          />
        </Field>
        <Field label="Extended Care Waiver" style={{}}>
          <Input
            value={withdrawal?.extended_care_waiver}
            onChange={handleInputChange('extended_care_waiver')}
          />
        </Field>
      </div>
    </>
  );
}

export default WithdrawalsAndSurrenders;
